module.exports = __webpack_public_path__ + "img/解决方案标题.d1151496.png";